import { withNamespaces } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { buildCreateMeasurePayload } from "../helpers/measureForm";
import useCreatePositiveListMeasure from "../hooks/useCreatePositiveListMeasure";
import MeasureFormFields from "./MeasureFormFields";

const CreateMeasureModal = ({
    isOpen,
    softwareId,
    onClose,
    onCreated,
    t,
}) => {
    const createMutation = useCreatePositiveListMeasure({
        softwareId,
        t,
        onSuccess: (measure) => {
            onCreated(measure);
            onClose();
        },
    });

    const handleSubmit = (_event, values) => {
        createMutation.mutate(buildCreateMeasurePayload(values));
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered>
            <ModalHeader toggle={onClose}>
                {t("Add measure")}
            </ModalHeader>
            <ModalBody>
                {isOpen && (
                    <MeasureFormFields
                        formKey="create-measure"
                        allowEmptyAdoption
                        isSaving={createMutation.isLoading}
                        onSubmit={handleSubmit}
                        onCancel={onClose}
                        t={t}
                    />
                )}
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(CreateMeasureModal);
